import React, { useEffect, useState } from 'react';
import { Users, FileText, Link2, Clock } from 'lucide-react';
import { api, DEMO } from '../lib/api';
import '../components/PhpTherapy.css';

export default function PhpComplianceReport({ user, facility, notify }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (DEMO) { setData(null); return; }
    api('/php/compliance-report').then(setData).catch(e => notify(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const d = data || {};
  const over = d.over_capacity || [];
  const overlaps = d.overlapping_services || [];

  const stat = (Icon, label, n, note) => (
    <div className="php-ov-card"><span className="php-ov-label">{label}</span><div className="php-ov-value"><Icon size={16}/> {n}</div>{note && <small className="muted">{note}</small>}</div>
  );

  return <>
    <div className="page-heading"><div><div className="eyebrow">{facility?.name || 'YOUR FACILITY'} · COMPLIANCE REVIEW</div><h1>PHP therapy documentation review.</h1><p>Review indicators to guide documentation quality — never an automatic determination of fraud, abuse, or noncompliance.</p></div></div>

    {DEMO && <div className="php-safety-alert" style={{ borderColor: '#b45309', background: '#fffbeb', color: '#92400e' }}><div><strong>Compliance review requires live data.</strong><p>Indicators are computed server-side from therapy, attendance, and treatment-plan records and are available in the authenticated (non-demo) workspace.</p></div></div>}

    {!DEMO && data && (
      <>
        <div className="registry-stats" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))' }}>
          {stat(Users, 'Groups over capacity', over.length, over.length ? 'Reconcile roster against configured capacity.' : 'None over capacity.')}
          {stat(FileText, 'Unsigned attended responses', d.unsigned_responses ?? 0, 'Attended responses awaiting signature.')}
          {stat(FileText, 'Missing individualized responses', d.missing_individualized_responses ?? 0, 'Attended with no individualized narrative.')}
          {stat(Link2, 'Missing treatment-plan linkage', d.missing_treatment_plan_linkage ?? 0, 'Attended responses not linked to a plan.')}
          {stat(Clock, 'Overlapping rendered services', overlaps.length, overlaps.length ? 'Review simultaneous service records.' : 'No overlaps detected.')}
        </div>

        {over.length > 0 && (
          <section className="registry-panel practice-page">
            <div className="content-heading"><div><h3>Groups over capacity</h3></div></div>
            <div className="table-scroll"><table>
              <thead><tr><th>Group</th><th>Assigned</th><th>Capacity</th></tr></thead>
              <tbody>{over.map(g => <tr key={g.group_session_id}><td><strong>{g.name}</strong></td><td>{g.assigned_count}</td><td>{g.capacity}</td></tr>)}</tbody>
            </table></div>
          </section>
        )}

        {overlaps.length > 0 && (
          <section className="registry-panel practice-page">
            <div className="content-heading"><div><h3>Overlapping rendered services</h3><p>Warnings only — service times are never altered automatically.</p></div></div>
            <div className="table-scroll"><table>
              <thead><tr><th>Patient</th><th>First service</th><th>Second service</th><th>Overlap</th></tr></thead>
              <tbody>{overlaps.map((o, i) => <tr key={i}><td>{o.patient_id ?? o.mrn ?? '—'}</td><td>{o.service_a || '—'}</td><td>{o.service_b || '—'}</td><td>{o.overlap_minutes ? `${o.overlap_minutes} min` : '—'}</td></tr>)}</tbody>
            </table></div>
          </section>
        )}
      </>
    )}
  </>;
}
